import { gql } from '@apollo/client';


export const ADD_OR_UPDATE_SCALE_IN_SIZE_AND_WEIGHT = gql`
mutation addOrUpdateScaleInSizeAndWeight($input: AddOrUpdateScaleInSizeAndWeightInput!) {
  addOrUpdateScaleInSizeAndWeight(input: $input) {
    clientMutationId
    errors
    sizeAndWeight {
      id
    }
    scale {
      id
      name
      position
      scaleMake {
        id
        name
      }
      scaleModel {
        id
        name
      }
      serialNumber
    }
  }
}
`